import evidence_file_request_icon from "../../assets/images/task/evidence_file_request.svg";

export const ADMINISTRATIVE_CERTIFICATE_TYPES = [
  {
    label: '전체',
    id: ''
  },
  {
    label: '사업자 등록증명',
    id: 'B0001',
    icon: evidence_file_request_icon
  },
  {
    label: '소득금액증명',
    id: 'B1022',
    icon: evidence_file_request_icon
  },
  {
    label: '납부내역(납세사실)증명',
    id: 'B0005',
    icon: evidence_file_request_icon
  },

  {
    label: '납세(국세완납)증명',
    id: 'B0006',
    icon: evidence_file_request_icon
  },
  {
    label: '표준재무제표증명',
    id: 'B1003',
    icon: evidence_file_request_icon
  },
  {
    label: '부가가치세과세표준증명',
    id: 'B4009',
    // disabled: true,
    icon: evidence_file_request_icon
  },

  {
    label: '면세사업수입금액증명',
    id: 'B1002',
    icon: evidence_file_request_icon
  }
];

// B0001 : 사업자등록증명  1
// B0011 : 사업자등록증명(복수사업자)
// B1003 : 표준재무제표증명 5
// B1002 : 면세사업수입금액증명 7
// B0005 : 납부내역(납세사실)증명 3
// B0006 : 납세(국세완납)증명 4
// B4009 : 부가가치세과세표준증명 6
// B1022 : 소득금액증명 2
// B1016 : 소득확인증명(개인종합자산관리계좌)
// B1019 : 소득확인증명(청년우대형주택청약종합저축)
// B1023 : 소득확인증명(청년형장기집합투자증권저축)
// B1024 : 소득확인증명(청년희망적금)


export const TAX_ITEM_CODES = [

  { value: "all", label: "전체" },
  { value: "10", label: "종합소득세" },
  { value: "11", label: "이자소득세" },
  { value: "12", label: "배당소득세" },
  { value: "13", label: "사업소득세" },
  { value: "14", label: "근로소득세(갑)" },
  { value: "15", label: "근로소득세(을)" },
  { value: "16", label: "기타소득세" },
  { value: "17", label: "연금소득세" },
  { value: "18", label: "기부장려금" },
  { value: "19", label: "근로장려금" },
  { value: "20", label: "자녀장려금" },
  { value: "21", label: "퇴직소득세" },
  { value: "22", label: "양도소득세" },
  { value: "23", label: "산림소득세" },
  { value: "31", label: "법인세" },
  { value: "32", label: "상속세" },
  { value: "33", label: "증여세" },
  { value: "34", label: "자산재평가세" },
  { value: "35", label: "부당이득세" },
  { value: "36", label: "토지초과이득세" },
  { value: "41", label: "부가가치세" },
  { value: "42", label: "특별소비세" },
  { value: "43", label: "주세" },
  { value: "44", label: "전화세" },
  { value: "45", label: "증권거래세" },
  { value: "46", label: "인지세" },
  { value: "47", label: "개별소비세" },
  { value: "51", label: "방위세" },
  { value: "52", label: "방위세(과년도)" },
  { value: "53", label: "교통세" },
  { value: "54", label: "교통세(과년도)" },
  { value: "55", label: "농특세" },
  { value: "56", label: "농특세(과년도)" },
  { value: "57", label: "종합부동산세" },
  { value: "59", label: "교통·에너지·환경세" },
  { value: "60", label: "교육세" },
  { value: "61", label: "교육세(이자분)" },
  { value: "62", label: "교육세(배당분)" },
  { value: "63", label: "교육세(주세분)" },
  { value: "64", label: "교육세(교통세)" },
  { value: "65", label: "교육세(금융)" },
  { value: "66", label: "교육세(보험)" },
  { value: "67", label: "교육세(특별소비세분)" },
  { value: "68", label: "기타교육세" },
  { value: "70", label: "토지대여료" },
  { value: "71", label: "토지대여료(과년도)" },
  { value: "72", label: "건물대여료" },
  { value: "73", label: "건물대여료(과년도)" },
  { value: "74", label: "기타재산수입" },
  { value: "75", label: "기타재산수입(과년도)" },
  { value: "76", label: "과태료" },
  { value: "77", label: "벌금" },
  { value: "78", label: "몰수금" },
  { value: "79", label: "변상금" },
  { value: "80", label: "위약금" },
  { value: "81", label: "가산금" },
  { value: "82", label: "가산금(과년도)" },
  { value: "83", label: "기타경상이전수입" },
  { value: "84", label: "징계부가금" },
  { value: "85", label: "관유물대여료" },
  { value: "86", label: "관유물대여료(과년도)" },
  { value: "87", label: "기타잡수입" },
  { value: "88", label: "수입대체경비" },
  { value: "89", label: "건물매각대" },
  { value: "90", label: "과징금" },
  { value: "91", label: "기타고정자산매각대" },
  { value: "92", label: "기타고정자산매각대(과년도)" },
  { value: "93", label: "토지매각대" },
  { value: "94", label: "토지매각대(과년도)" },
  { value: "95", label: "임야매각대" },
  { value: "96", label: "임야매각대(과년도)" },
  { value: "97", label: "기타토지및무형자산매각대" },
  { value: "98", label: "기타토지및무형자산매각대(과년도)" },
  { value: "99", label: "기타" },


]

